import { render } from "./AssignSalesRepToCustomersModal.html?vue&type=template&id=bccc6e28&scoped=true"
import script from "./AssignSalesRepToCustomersModal.js?vue&type=script&lang=js"
export * from "./AssignSalesRepToCustomersModal.js?vue&type=script&lang=js"

import "./AssignSalesRepToCustomersModal.css?vue&type=style&index=0&id=bccc6e28&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccc6e28"]])

export default __exports__